import Columnator from '@/lib/columnator.js';
import IndexView from '@/lib/index-view.js';

export default function () {
	new Columnator();
	new IndexView();
}
